import {useQuery, useQueryClient} from '@tanstack/react-query';
import {useEffect} from 'react';

import {FetchReviewsResultType} from '../../../../service/reviews/reviews-type';
import {getReviewsStatus} from '../../../../service/source-settings/accounts/accounts-api';
import {AccountReviewStatusesEnum} from '../../../../service/source-settings/accounts/accounts-type';

export function useReviewStatus(reviewsIds: Array<number>, reviewQueryKey: string): null {
    const queryClient = useQueryClient();

    const {data} = useQuery([`useReviewStatus${reviewsIds}`], () => getReviewsStatus({reviewsIds}), {
        enabled: Boolean(reviewQueryKey) && reviewsIds?.length > 0,
    });

    useEffect(() => {
        queryClient.setQueryData([reviewQueryKey], (oldData?: FetchReviewsResultType) => {
            if (!oldData) {
                return oldData;
            }

            const errorReviewIds = new Set(
                (data || [])
                    .filter((item) => item.accountStatus === AccountReviewStatusesEnum.errorStatus)
                    .flatMap((item) => item.reviewsIds)
            );

            if (errorReviewIds.size > 0) {
                return {
                    ...oldData,
                    results: oldData.results.map((review) => {
                        return errorReviewIds.has(review.id) ? {...review, hasAccountError: true} : review;
                    }),
                };
            }

            return oldData;
        });
    }, [data, queryClient, reviewQueryKey]);

    return null;
}
